import AttachmentList from '@/components/Attachments/AttachmentList.vue';

export default [
    {
        path: '/files',
        name: 'Files',
        meta: {
            requiresAuth: true
        },
        components: {
            page: AttachmentList
        }
    }
];